/**
 * Single source for API origin. Set at build time for production (S3, etc.):
 *
 *   REACT_APP_API_URL=http://YOUR_EC2_OR_API_HOST:3000/api/
 *
 * Local dev: use `REACT_APP_API_URL=/api/` in `.env.development` and `"proxy": "http://localhost:3000"`
 * in package.json so requests stay same-origin (no CORS / OPTIONS issues with the API).
 *
 * Trailing slash optional; normalized below.
 */
function normalizeApiBase(raw) {
  if (!raw || typeof raw !== "string") return null;
  const t = raw.trim();
  if (!t) return null;
  return t.endsWith("/") ? t : `${t}/`;
}

export function getApiBaseUrl() {
  const fromEnv = normalizeApiBase(process.env.REACT_APP_API_URL);
  if (fromEnv) return fromEnv;
  return "http://localhost:3000/api/";
}

/** Base for public (unauthenticated) quotation routes: .../api/public/ */
export function getPublicApiBaseUrl() {
  return `${getApiBaseUrl()}public/`;
}

/** Default tenant slug for public branded pages. */
export function getPublicTenantSlug() {
  return (process.env.REACT_APP_PUBLIC_TENANT_SLUG || 'ace-default').trim();
}
